var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIsracardSmall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 16,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 15,
  x: 0.5,
  y: 0.5,
  fill: "#fff",
  rx: 2.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 15,
  x: 0.5,
  y: 0.5,
  stroke: "#D9D9D9",
  rx: 2.5
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#isracardSmall_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EE2D24",
  d: "M4.584 7.476a.734.734 0 0 0 0 1.048l3.305 3.259c.293.29.768.29 1.062 0l3.304-3.259a.734.734 0 0 0 0-1.048L8.951 4.217a.76.76 0 0 0-1.062 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#352AFF",
  d: "M8.942 7.476a.734.734 0 0 0 0 1.048l3.304 3.259c.293.29.769.29 1.062 0l3.305-3.259a.734.734 0 0 0 0-1.048l-3.305-3.259a.76.76 0 0 0-1.062 0z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "isracardSmall_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.364 4h12.469v8H4.364z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIsracardSmall);
export default ForwardRef;